import { ksaAddDays, ksaDaysAgo, ksaToday } from "./ksaTime";
// dates.js — Single source of truth for "today" and ISO date strings in LOCAL
// time. `Date.toISOString()` is UTC-based; in Riyadh (UTC+3), a click at 12:30 AM
// local resolves to the previous day in UTC, which shifted the entire forecast
// table by one day. All callers must use these helpers to get a date that
// matches the device's wall-clock day.

/** Format a Date object as YYYY-MM-DD using the device's local timezone. */
export function dateToISO(d) {
  // ⑤/L3-أ — اليوم التقويمي بتوقيت السعودية (lib/ksaTime.js)، لا توقيت الجهاز.
  return ksaToday(d instanceof Date ? d : new Date(d));
}

/** Today (device local) as YYYY-MM-DD. */
export function todayISO() {
  return dateToISO(new Date());
}

/** N days ago/ahead (local). */
export function daysAgoISO(n) {
  return ksaDaysAgo(n);
}

export function daysAheadISO(n) {
  return ksaAddDays(ksaToday(), n);
}
